import { useThemeQueries } from "theme/util-styles"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import React from "react"
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { Box, Button, Grid, Typography } from "@material-ui/core"
import { TextFieldSaurus } from "components/inputs/text-field-saurus"
import { Controller, useForm } from "react-hook-form"
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario"
import { usePessoaUsuario } from "services/hooks/pessoa-usuario"
import { usePutPessoa } from "api/cardapio/queries/pessoa/put-pessoa"
import { useEmpresaAtual } from "services/hooks/empresa"
import { PessoaModel } from "api/cardapio/models/pessoa/pessoa-model"
import { useNotificacoes } from "components/notificacoes"
import { CircularLoading } from "components/utils/circular-loading"
import { EnumTipoContato } from "models/enums/enum-tipo-contato"
import { useFormPerfilValidation } from "./dialog-perfil-validations"
import { yupResolver } from "@hookform/resolvers/yup"
import { OkIcon } from "utils/Icons/ok-icon"
import { VoltarIcon } from "utils"
import { removerMascaraDocumento } from "utils/cpfcnpj-format"

export interface DialogPerfilProps {
    aberto: boolean,
}

export class PessoaFormModel {
    constructor(
        public nome: string = '',
        public email: string = '',
        public telefone: string = '',
        public cpfcnpj: string = '',
    ) { }
}

export const DialogPerfil = ({ aberto }: DialogPerfilProps) => {
    const { isMobile } = useThemeQueries()
    const { openCloseDialog } = useDialogStore()

    const { pessoa } = usePessoaUsuarioStore()
    const { getEmpresaAtual } = useEmpresaAtual()
    const { carregarPessoa, carregando: carregandoCarregarPessoa } = usePessoaUsuario()
    const { putPessoa, carregando: carregandoPutPessoa } = usePutPessoa()
    const { showSuccessMessage, showErrorMessage } = useNotificacoes()

    const carregando = carregandoCarregarPessoa || carregandoPutPessoa

    const onSubmit = async (model: PessoaFormModel) => {
        try {

            const pessoaPraAlterar = pessoa ?? new PessoaModel()
            pessoaPraAlterar.nome = model.nome
            pessoaPraAlterar.cpfcnpj = removerMascaraDocumento(model.cpfcnpj)

            await putPessoa(pessoaPraAlterar, getEmpresaAtual()?.id ?? '')
            showSuccessMessage("Perfil atualizado com sucesso!")
            carregarPessoa()
            openCloseDialog(EnumDialogs.Perfil, false)
        } catch (e: any) {
            showErrorMessage(e.message);
        }
    }
    const { FormPerfilYupValidation } = useFormPerfilValidation()

    const {
        handleSubmit,
        control,
        formState: {
            errors
        }
    } = useForm<PessoaFormModel>({
        defaultValues: {
            nome: pessoa?.nome || '',
            email: pessoa?.contatos?.find(x => x.tipo === EnumTipoContato.EMAIL)?.valor || '',
            telefone: pessoa?.contatos?.find(x => x.tipo === EnumTipoContato.TELEFONE)?.valor || '',
            cpfcnpj: pessoa?.cpfcnpj || '',
        },
        resolver: yupResolver(FormPerfilYupValidation),
    })

    return (
        <DialogSaurus
            aberto={aberto}
            titulo="Informações de Perfil"
            isButtonTitleClose
            tamanho="sm"
            fullScreen={isMobile}
            handleClickClose={() => openCloseDialog(EnumDialogs.Perfil, false)}
            removerPaddingContent
            bottomArea={
                <Box p={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button size="large" onClick={() => handleSubmit(onSubmit)()} variant="contained" color="primary" fullWidth>
                                <OkIcon tipo="BUTTON_PRIMARY" />
                                Salvar
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button size="large" onClick={() => openCloseDialog(EnumDialogs.Perfil, false)} variant="outlined" color="primary" fullWidth >
                                <VoltarIcon tipo="BUTTON" />
                                Voltar
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            }
        >
            {carregando && <CircularLoading tipo="FULLSIZED" titulo="Atualizando perfil..." />}
            <Box p={2} component="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography>
                            Altere suas informações de perfil caso necessário, esses dados serão informados no pedido realizado.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <Controller
                            name="nome"
                            control={control}
                            render={({ field }) => (
                                <TextFieldSaurus
                                    tipo="TEXTO"
                                    {...field}
                                    label="Nome"
                                    allowSubmit
                                    helperText={errors.nome?.message}
                                    error={Boolean(errors.nome)}

                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Controller
                            name="cpfcnpj"
                            control={control}
                            render={({ field }) => (
                                <TextFieldSaurus
                                    tipo="CNPJ_CPF"
                                    {...field}
                                    label="CPF/CNPJ"
                                    allowSubmit
                                    helperText={errors.cpfcnpj?.message}
                                    error={Boolean(errors.cpfcnpj)}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <Controller
                            name="email"
                            control={control}
                            render={({ field }) => (
                                <TextFieldSaurus
                                    tipo="TEXTO"
                                    {...field}
                                    label="Email"
                                    allowSubmit
                                    readOnly
                                    helperText={errors.email?.message}
                                    error={Boolean(errors.email)}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Controller
                            name="telefone"
                            control={control}
                            render={({ field }) => (
                                <TextFieldSaurus
                                    tipo="TELEFONE"
                                    {...field}
                                    label="Telefone"
                                    allowSubmit
                                    readOnly
                                    helperText={errors.telefone?.message}
                                    error={Boolean(errors.telefone)}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <button style={{ display: 'none' }} type="submit"></button>
            </Box>
        </DialogSaurus>
    )
}